import * as React from 'react';

import cn from 'classnames';

export const Badge: React.FC<{
  pill?: boolean;
  style: 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info' | 'light' | 'dark';
}> = ({ style, pill, children }) => (
  <span className={cn('badge', style && `badge-${style}`, pill && 'badge-pill')}>{children}</span>
);
